import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    title: 'Colors',
    attributeName: 'mainhubCustomizationColors',
    fields: [
        {
            attributeName: 'primaryColor',
            helpText: 'The general color of the black label app. if you setup this color first, the XMS calculate the rest of the colors.',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Primary Color',
        },
        {
            attributeName: 'secondaryColor',
            helpText: 'The secondary color of the black label app.',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Secondary Color',
        },
        {
            attributeName: 'accentColor',
            helpText: 'The accent color of the black label app.',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Accent Color',
        },
        /*{
            attributeName: 'extendColors',
            type: FormInputTypes.BUTTON_FORM,
            mode:'button',
            label: 'Extend colors',
            confirm:true,
            actionUrl:'blackLabelCustomizationExtend',
            title:"Are you sure you want to extend colors?",
            description:"You are about to generate the hole set of colors based on the Room color established. This process will replace the current values for all the colors in this form",
            className:'ml-3 float-left'
        },
        {
            attributeName: 'clearColors',
            type: FormInputTypes.BUTTON_FORM,
            mode:'button',
            label: 'Clear colors',
            confirm:true,
            actionUrl:'blackLabelCustomizationClear',
            title:"Are you sure you want to clear all colors?",
            description:"You are about to clear the hole set of customization colors for this sportroom",
            className:'ml-3 float-left'
        },*/
        {
            attributeName:"sep1",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'layoutHover',
            helpText: 'Various interactive elements on hover have an animated gradient stroke around them. These are the elements: Video Poster, Highlighted Content Panel, Carousel Panel, Camera on hover on Control Room',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Layout Hover',
        },
        {
            attributeName: 'primaryButtonBackogrundColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Primary Button Background Color',
        },
        {
            attributeName: 'primaryButtonTextColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Primary Button Text Color',
        },
        {
            attributeName: 'secondaryButtonBackogrundColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Secondary Button Background Color',
        },
        {
            attributeName: 'secondaryButtonTextColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Secondary Button Text Color',
        },
        {
            attributeName: 'navbarButtonBackgroundColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Category Bar color', //before it was Navbar Background Color',
        },
        {
            attributeName: 'navbarButtonTextColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Category Bar text color', //'Navbar Text Color',
        },
        {
            attributeName: 'personalUIBackgroundColor',
            helpText: 'Main buttons in the Personal UI.',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Personal UI Background Color',
        },
        {
            attributeName: 'personalUITextColor',
            helpText: 'Main buttons in the Personal UI.',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Personal UI Text Color',
        },
        {
            attributeName: 'sliderColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Slider Color',
        },
        {
            attributeName:"sep2",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'fontTitleColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Font Title Color',
        },
        {
            attributeName: 'fontSubtitleColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Font Subtitle Color',
        },
        {
            attributeName:"sep3",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'liveTagsColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Live Tags Color',
        },
        {
            attributeName: 'commingSoonTagsColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Coming Soon Tags Color',
        },
        {
            attributeName: 'ticketTagsColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Ticket Tags Color',
        },
        {
            attributeName:"sep4",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'videoPlayerNotificationColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Video Player Notification Color',
        },
        {
            attributeName: 'socialNotificationColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Social Notification Color',
        },
        {
            attributeName: 'purchaseNotificationColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Purchase Notification Color',
        },
        {
            attributeName: 'inAppNotificationColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'In-App Notification Color',
        },
        {
            attributeName:"sep5",
            type:FormInputTypes.SEPARATOR
        },
        {
            attributeName: 'loadingAnimationColor',
            helpText: '',
            type: FormInputTypes.COLOR_PICKER,
            label: 'Loading Animation Color',
        },
    ]
}